// Do NOT add "use client" to this file
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import { NotifyMeProps } from "./NotifyMeProps";

export const notifyMeProductTileAdaptor = (
  productTile: ILeanProductTile
): NotifyMeProps => {
  return {
    productToken: productTile.product?.token,
    productOptionToken: productTile?.quick_add?.quick_add_option?.option_token,
    productState: productTile?.product?.state,
    isSubscribedToBackInStockNotification:
      productTile.product?.is_subscribed_to_back_in_stock_notification ?? false,
    brandToken: productTile.product?.brand_token,
  };
};
